import { type Services_userProfile$data } from '@/__generated__/relay/Services_userProfile.graphql.js';

type ServiceNodes = Array<
  Services_userProfile$data['productizedServices']['edges'][0]['node']
>;

export const getVisibleServices = (
  productizedServices: Services_userProfile$data['productizedServices'],
): ServiceNodes => productizedServices?.edges.map(({ node }) => node) ?? [];
